module.exports = {"text":"Verze {version}"}